import { useEffect, useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import { collectionStandards } from '@/mocks/home';

export default function SubmitCta() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <section id="submit" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-50">
            <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-12 md:items-center md:gap-10 md:p-10">
              <div className="md:col-span-8">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-inbox-archive-line text-2xl" />
                </span>
                <h2 className="mt-5 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  把好站点交给黑料导航
                </h2>
                <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-600">
                  如果你常逛的站点还没被收进来，可以按下面的标准自行对照。收录会优先补充到
                  <strong className="mx-1 font-semibold text-foreground-900">黑料导航分类</strong>
                  最贴近的那一格，让黑料导航网站大全保持好用。
                </p>
                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                  <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-file-list-3-line text-base" />
                    查看收录标准
                  </button>
                  <a
                    href="#categories"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 font-label text-sm text-primary-700 transition-colors hover:bg-primary-100"
                  >
                    <i className="ri-compass-3-line text-base" />
                    先逛逛分类
                  </a>
                </div>
              </div>

              <div className="md:col-span-4">
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { icon: 'ri-timer-flash-line', label: '更新巡检', value: '每日' },
                    { icon: 'ri-layout-grid-line', label: '分类维度', value: '8 大类' },
                    { icon: 'ri-shield-check-line', label: '人工复核', value: '全量' },
                    { icon: 'ri-history-line', label: '快讯归档', value: '可回溯' },
                  ].map((item) => (
                    <div
                      key={item.label}
                      className="rounded-md border border-primary-200 bg-background-50 px-3 py-3.5"
                    >
                      <span className="flex h-7 w-7 items-center justify-center rounded bg-accent-100 text-accent-800">
                        <i className={`${item.icon} text-base`} />
                      </span>
                      <p className="mt-2.5 font-heading text-sm font-bold text-foreground-950">
                        {item.value}
                      </p>
                      <p className="mt-0.5 font-label text-[11px] text-foreground-500">
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div className="relative w-full max-w-lg rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">收录标准说明</h3>
                <p className="mt-1 font-label text-xs text-foreground-500">
                  对照以下几条，符合即可提交
                </p>
              </div>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setOpen(false)}
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:bg-background-100"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>

            <ul className="mt-5 space-y-3">
              {collectionStandards.map((item, index) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 font-display text-[11px] font-black text-primary-700">
                    {index + 1}
                  </span>
                  <span className="text-sm leading-7 text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                我知道了
              </button>
              <a
                href="#comments"
                onClick={() => setOpen(false)}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-chat-forward-line text-base" />
                去互动广场留言
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}